import { Outlet , ScrollRestoration } from 'react-router-dom';
import Header from '../components/navigation';
import Footer from '../components/Footer';

function Layout(products) {
  return (
    <>
      <Header products={products}/>
      <main>
      <ScrollRestoration />
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default Layout